import { render } from "./case-detail.vue?vue&type=template&id=4cc1d0ec&scoped=true&ts=true"
import script from "./case-detail.vue?vue&type=script&lang=ts"
export * from "./case-detail.vue?vue&type=script&lang=ts"

import "./case-detail.vue?vue&type=style&index=0&id=4cc1d0ec&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc1d0ec"]])

export default __exports__